/**
 * CS (Customer Service) Routes - Nested Routes
 */
export default [
    {
        path: '/cs',
        component: () => import('../../pages/cs/IndexPage.vue'),
        meta: {
            layout: 'default',
            requiresAuth: true,
        },
        children: [
            {
                path: '',
                redirect: '/cs/list/1',
            },
            {
                path: 'list/:pageNo',
                name: 'csList',
                component: () => import('../../pages/cs/ListPage.vue'),
                meta: { title: 'Customer Service' },
            },
            {
                path: 'view/:idx',
                name: 'csView',
                component: () => import('../../pages/cs/ViewPage.vue'),
                meta: { title: 'View Inquiry' },
            },
            {
                path: 'write',
                name: 'csWrite',
                component: () => import('../../pages/cs/WritePage.vue'),
                meta: { title: 'New Inquiry' },
            },
            {
                path: 'edit/:idx',
                name: 'csEdit',
                component: () => import('../../pages/cs/WritePage.vue'),
                meta: { title: 'Edit Inquiry' },
            },
        ],
    },
];
